import React, { useState, useEffect, useRef } from 'react';

/**
 * Animated counter that counts from 0 to `value` when scrolled into view.
 * Triggers only once using IntersectionObserver.
 */
export default function AnimatedCounter({ value, duration = 1500, suffix = '', prefix = '', className = '', testId }) {
  var [display, setDisplay] = useState(0);
  var [started, setStarted] = useState(false);
  var ref = useRef(null);

  useEffect(function() {
    if (!ref.current || started) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(ref.current);
    return function() { try { observer.disconnect(); } catch(e) {} };
  }, [started]);

  useEffect(function() {
    if (!started) return;
    var target = Number(value) || 0;
    if (target === 0) { setDisplay(0); return; }
    var start = null;
    var from = 0;
    var step = function(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // easeOutCubic for a smooth decel
      var eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.floor(from + (target - from) * eased));
      if (progress < 1) requestAnimationFrame(step);
      else setDisplay(target);
    };
    requestAnimationFrame(step);
  }, [started, value, duration]);

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {prefix}{display.toLocaleString('es-CL')}{suffix}
    </span>
  );
}
